import { EventNotificationPush } from './EventNotificationPush';
import { Injectable, NgZone } from '@angular/core';
import { AlertController } from '@ionic/angular';
// import { Events } from '@ionic/angular';  // deprecated in Ionic 5
import { Events } from 'src/app/services/events/events.service'; 
import { TranslateService } from '@ngx-translate/core';

/*
  NOTE:  There are THREE MAIN CATEGORIES OF PUSH NOTIFICATIONS:
  (1) Survey Notification (with ability to answer survey)
  (2) Actionable Notification (with ability to execute action)
  (3) Ambit Message (various sub-categories, see below)
    - Ambit Message: Assignment (Support, Report, Door Access)
    - Ambit Message: Notification (Support, Report, Door Access, Reference updates, etc.)
    - Ambit Message: Simple message (from System Client "SendAmbitMessage" button)
    - Ambit Message: Test Push (from Mobile App "Test Push" button)
*/

// add my services and common stuff here
import * as Constants from 'src/app/services/constants/constants';
import { GlobalService } from 'src/app/services/global/global.service';
import { CommonService } from 'src/app/services/common/common.service';
import { NotificationData } from 'src/app/services/global/structure';
import { ApiService } from 'src/app/services/api/api.service';
import { BroadcastPush } from './BroadcastPush';
import { AmbitMessagePush } from './AmbitMessagePush';
import { AmbitPushGeneral } from './AmbitPushGeneral';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {

  private consoleLog:boolean = false;

  public notification: any;
  private _isNotification:boolean = false;

  data = "init data";

  constructor(private alertController: AlertController
    , public events: Events
    , public globalProvider: GlobalService
    , private commonProvider:CommonService
    , public translate: TranslateService
    , public apiProvider: ApiService 
    , public zone: NgZone 
    //, private push: Push
  ) 
  {
    this.consoleLog = this.globalProvider.consoleLog_notification;
    if (this.consoleLog) console.log('Notification.ctor - LifeCycle');
    //this.InitializeProvider();

    //this.platform.ready().then(() => {
    //  this.InitializeProvider();
    //});
  }

  // ref: https://stackoverflow.com/questions/43387855/singletons-in-ionic-3-angular-4
  set(context, data){
    if (this.consoleLog) console.log("set - context:" + context + " from data:" + this.data + " to:" + data);   
    this.data = data;
  }
  log(context:string){
    if (this.consoleLog) console.log("log - context:" + context + " data:" + this.data);   
  }

  // use this to initialize each screen's Notification status
  public IsNotification():boolean
  {
    return this._isNotification;
  }

  
  TriggerNotificationTest(context:string, secondsBeforeAlert:number, abstractId:number) 
  {
    console.log("(" + context + ") - " + "Notification.TriggerNotificationTest in " + secondsBeforeAlert + " seconds. " + " Currently _isNotification:" + this._isNotification );
		setTimeout(() => {
      console.log("(" + context + ") - " + "Notification.TriggerNotificationTest time elapsed (" + secondsBeforeAlert + "). " + " Switching from _isNotification:" + this._isNotification );
      
      // ----------------------------------------------------------
      let _NotificationData = new NotificationData();
      _NotificationData.NotificationSourceCode = Constants.NOTIFICATION_SOURCE_OTHER; 
      _NotificationData.NotificationTypeCode = Constants.NOTIFICATION_TYPE_SURVEY;
      _NotificationData.IsActive = true;
      _NotificationData.SurveyBroadcastId = abstractId; // 16347; // 1234567890;
      this.PublishNotificationAlert(_NotificationData);
      // ----------------------------------------------------------

    }, secondsBeforeAlert*1000);
  }

  // ========================================================================================
  // CHECK UNSEEN -  SURVEY, ACTIONABLE, EVENT NOTIFICATION, AMBIT MESSAGE
  // ========================================================================================
  public CheckUnseenNotifications(apiResponse:any, context:string)
  {
    if ((!apiResponse) || (!apiResponse.MobileEventLatest)) { return; }  // basic check upfront
  
    this.CheckUnseenSurveyBroadcast(apiResponse.MobileEventLatest.Survey, context);
    this.CheckUnseenActionableBroadcast(apiResponse.MobileEventLatest.Actionable, context);
    this.CheckUnseenAmbitMessage(apiResponse.MobileEventLatest.AmbitMessage, context);
    this.CheckUnseenEventNotification(apiResponse.MobileEventLatest.EventNotification, context);
  }

  // ----------------------------------------------------------------------------------------
  // PUSH or UNSEEN - SURVEY BROADCAST
  // ----------------------------------------------------------------------------------------

  public CheckUnseenSurveyBroadcast(Api_Survey:any, context:string)
  {
    if (this.consoleLog) console.log("Notification.CheckUnseenSurveyBroadcast: " + context, Api_Survey);
   
    try
    {
      if ((!Api_Survey) || (!Api_Survey.SurveyBroadcastId)) { return; }  // basic check upfront

      if (this.consoleLog) console.log("Notification.CheckUnseenSurveyBroadcast: " + context + " - SURVEY - checking SurveyBroadcastId:" + Api_Survey.SurveyBroadcastId, Api_Survey);
      let SurveyBroadcastIdInteger:number = parseInt(Api_Survey.SurveyBroadcastId, 10);
      let SurveyRecipientIdInteger:number = parseInt(Api_Survey.SurveyRecipientId, 10);
      if (!this.globalProvider.LatestSurvey.HasThisSurveyBeenSeenAlready(SurveyBroadcastIdInteger))
      {
        if (this.consoleLog) console.log("Notification.CheckUnseenSurveyBroadcast: " + context + " - SURVEY - UNSEEN so will TRIGGER SurveyBroadcastId:" + Api_Survey.SurveyBroadcastId, Api_Survey);
        // mark this as RECEIVED so that we don't double up (even though it is in the process of being received)
        this.globalProvider.SetStorageObject_LatestActionableForm(SurveyBroadcastIdInteger, SurveyRecipientIdInteger, "RECEIVED");
        this.TriggerUnseenSurvey(Api_Survey, SurveyBroadcastIdInteger, context);
      } 
      else
      {
        if (this.consoleLog) console.log("Notification.CheckUnseenSurveyBroadcast: " + context + " - SURVEY - ALREADY SEEN SurveyBroadcastId:" + Api_Survey.SurveyBroadcastId, Api_Survey);
      }
    }
    catch (error)
    {
      console.error("Notification.CheckUnseenSurveyBroadcast: exception", error);
    }
  }

  public TriggerUnseenSurvey(Api_Survey:any, SurveyBroadcastId:number, context:string)
  {
    //if (this.consoleLog) 
    console.log("Notification.TriggerUnseenSurvey: SURVEY  - BroadcastId:" + SurveyBroadcastId + " - " + context);
    
    let _NotificationData = new NotificationData();
    _NotificationData.NotificationSourceCode = Constants.NOTIFICATION_SOURCE_UNSEEN; 
    _NotificationData.NotificationTypeCode = Constants.NOTIFICATION_TYPE_SURVEY; // "SURVEY";
    _NotificationData.IsActive = true;

    _NotificationData.SurveyBroadcastId = SurveyBroadcastId;

    // Specific details from API response via Suvey
    // _NotificationData.MessageTitle = Api_Survey.NotificationTypeCode; // .MessageTitle;
    // _NotificationData.MessageSubTitle = Api_Survey.StructuredFormMessageLevelCode; // .MessageSubTitle;
    // _NotificationData.MessageText = Api_Survey.StructuredFormMessageText; // .MessageText;

    this.PublishNotificationAlert(_NotificationData);

    /*
      MobileEventLatest:
        Survey:
          DeviceReceiveDatetimeUtc: "2019-05-14T18:28:12.643"
          LiveFlag: true
          MessagePushDatetimeUtc: "2019-05-14T18:28:10.723"
          PriorityFlag: false
          ResponseChoiceCount: 2
          SurveyBroadcastId: 17701
          SurveyRecipientId: 120309
          SurveyResponseStatusCode: "RESPONDED"
          SystemSentDatetimeUtc: "2019-05-14T18:28:10.723"
          UserResponseDatetimeUtc: "2019-05-14T18:28:25.73"
    */
  }

  public TriggerPushSurveyDisplay(ambitPushGeneral:AmbitPushGeneral, broadcastPush:BroadcastPush, ForegroundStatus:string)
  {
    if (this.consoleLog) console.log("Notification.TriggerPushSurveyDisplay: " + ForegroundStatus, ambitPushGeneral);
    
    let _NotificationData = new NotificationData();
    _NotificationData.NotificationSourceCode = Constants.NOTIFICATION_SOURCE_PUSH; 
    _NotificationData.NotificationTypeCode = Constants.NOTIFICATION_TYPE_SURVEY;
    _NotificationData.IsActive = true;

    _NotificationData.SurveyBroadcastId = ambitPushGeneral.SurveyBroadcastId; 

    // Specific details from Push Notification via broadcastPush (these are not used really, since the Modal window calls an API to get the data to display)
    _NotificationData.MessageTitle = broadcastPush.NotificationTypeCode; // .MessageTitle;
    _NotificationData.MessageSubTitle = broadcastPush.StructuredFormMessageLevelCode; // .MessageSubTitle;
    _NotificationData.MessageText = broadcastPush.StructuredFormMessageText; // .MessageText;

    this.PublishNotificationAlert(_NotificationData);
  }

  // ----------------------------------------------------------------------------------------
  // PUSH or UNSEEN - ACTIONABLE BROADCAST
  // ----------------------------------------------------------------------------------------

  public CheckUnseenActionableBroadcast(Api_Actionable:any, context:string)
  {
    if (this.consoleLog) console.log("Notification.CheckUnseenActionableBroadcast: " + context, Api_Actionable);
   
    try
    {
      if ((!Api_Actionable) || (!Api_Actionable.SurveyBroadcastId)) { return; }  // basic check upfront

      if (this.consoleLog) console.log("Notification.CheckUnseenActionableBroadcast: " + context + " - ACTIONABLE - checking BroadcastId:" + Api_Actionable.SurveyBroadcastId, Api_Actionable);
      let ActionableBroadcastIdInteger:number = parseInt(Api_Actionable.SurveyBroadcastId, 10);
      let ActionableRecipientIdInteger:number = parseInt(Api_Actionable.SurveyRecipientId, 10);
      if (!this.globalProvider.LatestActionableForm.HasThisActionableFormBeenSeenAlready(ActionableBroadcastIdInteger))
      {
        if (this.consoleLog) console.log("Notification.CheckUnseenActionableBroadcast: " + context + " - ACTIONABLE - UNSEEN so will TRIGGER BroadcastId:" + Api_Actionable.SurveyBroadcastId, Api_Actionable);
        // mark this as RECEIVED so that we don't double up (even though it is in the process of being received)
        this.globalProvider.SetStorageObject_LatestActionableForm(ActionableBroadcastIdInteger, ActionableRecipientIdInteger, "RECEIVED");
        this.TriggerUnseenActionableForm(Api_Actionable, ActionableBroadcastIdInteger, context);
      } 
      else
      {
        if (this.consoleLog) console.log("Notification.CheckUnseenActionableBroadcast: " + context + " - ACTIONABLE - ALREADY SEEN BroadcastId:" + Api_Actionable.SurveyBroadcastId, Api_Actionable);
      }
    }
    catch (error)
    {
      console.error("Notification.CheckUnseenActionableBroadcast: exception", error);
    }
  }

  public TriggerUnseenActionableForm(Api_Actionable:any, ActionableBroadcastId:number, context:string)
  {
    //if (this.consoleLog) 
    console.log("Notification.TriggerUnseenActionableForm: ACTIONABLE - BroadcastId:" + ActionableBroadcastId + " - " + context);
    
    let _NotificationData = new NotificationData();
    _NotificationData.NotificationSourceCode = Constants.NOTIFICATION_SOURCE_UNSEEN; 
    _NotificationData.NotificationTypeCode = Constants.NOTIFICATION_TYPE_ACTIONABLE; // "SURVEY";
    _NotificationData.IsActive = true;

    _NotificationData.ActionableBroadcastId = ActionableBroadcastId;

    // Specific details from API response via Actionable (these are not used really, since the Modal window calls an API to get the data to display)
    // _NotificationData.MessageTitle = Api_Actionable.NotificationTypeCode; // .MessageTitle;
    // _NotificationData.MessageSubTitle = Api_Actionable.StructuredFormMessageLevelCode; // .MessageSubTitle;
    // _NotificationData.MessageText = Api_Actionable.StructuredFormMessageText; // .MessageText;

    this.PublishNotificationAlert(_NotificationData);

    /*
      MobileEventLatest:
        Actionable:
          ActionableBroadcastId: 17704
          ActionableRecipientId: 120319
          DeviceReceiveDatetimeUtc: "2019-05-14T22:42:53.663"
          LiveFlag: true
          MessagePushDatetimeUtc: "2019-05-14T22:28:27.923"
          PriorityFlag: true
          ResponseChoiceCount: 3
          SurveyBroadcastId: 17704
          SurveyRecipientId: 120319
          SurveyResponseStatusCode: "RECEIVED"
          SystemSentDatetimeUtc: "2019-05-14T22:28:27.923"
          UserResponseDatetimeUtc: "0001-01-01T00:00:00"
    */
  }
   
  public TriggerPushActionableFormDisplay(ambitPushGeneral:AmbitPushGeneral, broadcastPush:BroadcastPush, ForegroundStatus:string)
  {
    if (this.consoleLog) console.log("Notification.TriggerPushActionableFormDisplay: " + ForegroundStatus, ambitPushGeneral);
    
    let _NotificationData = new NotificationData();
    _NotificationData.NotificationSourceCode = Constants.NOTIFICATION_SOURCE_PUSH; 
    _NotificationData.NotificationTypeCode = Constants.NOTIFICATION_TYPE_ACTIONABLE; // "SURVEY";
    _NotificationData.IsActive = true;

    _NotificationData.ActionableBroadcastId = ambitPushGeneral.ActionableBroadcastId;

    // Specific details from Push Notification via broadcastPush (these are not used really, since the Modal window calls an API to get the data to display)
    _NotificationData.MessageTitle = broadcastPush.NotificationTypeCode; // .MessageTitle;
    _NotificationData.MessageSubTitle = broadcastPush.StructuredFormMessageLevelCode; // .MessageSubTitle;
    _NotificationData.MessageText = broadcastPush.StructuredFormMessageText; // .MessageText;

    this.PublishNotificationAlert(_NotificationData);
  }

  // ----------------------------------------------------------------------------------------
  // PUSH or UNSEEN - EVENT NOTIFICATION (similar to AmbitMessage)
  // ----------------------------------------------------------------------------------------

  public CheckUnseenEventNotification(Api_EventNotification:any, context:string)
  {
    if (this.consoleLog) console.log("Notification.CheckUnseenEventNotification: " + context, Api_EventNotification);
   
    try
    {
      if ((!Api_EventNotification) || (!Api_EventNotification.AmbitMessageId)) { return; }  // basic check upfront

      if (this.consoleLog) console.log("Notification.CheckUnseenEventNotification: " + context + " - EVENTNOTIFICATION - checking AmbitMessageId:" + Api_EventNotification.AmbitMessageId, Api_EventNotification);
      let AmbitMessageIdInteger:number = parseInt(Api_EventNotification.AmbitMessageId, 10);
      let EventIdInteger:number = parseInt(Api_EventNotification.EventId, 10);
      if (!this.globalProvider.LatestEventNotification.HasThisEventNotificationBeenSeenAlready(AmbitMessageIdInteger))
      {
        if (this.consoleLog) console.log("Notification.CheckUnseenEventNotification: " + context + " - EVENTNOTIFICATION - UNSEEN so will TRIGGER AmbitMessageId:" + Api_EventNotification.AmbitMessageId, Api_EventNotification);
        // mark this as RECEIVED so that we don't double up (even though it is in the process of being received)
        this.globalProvider.SetStorageObject_LatestEventNotification(AmbitMessageIdInteger, EventIdInteger, "RECEIVED");
        this.TriggerUnseenEventNotification(Api_EventNotification, AmbitMessageIdInteger, context);
      } 
      else
      {
        if (this.consoleLog) console.log("Notification.CheckUnseenEventNotification: " + context + " - EVENTNOTIFICATION - ALREADY SEEN AmbitMessageId:" + Api_EventNotification.AmbitMessageId, Api_EventNotification);
      }
    }
    catch (error)
    {
      console.error("Notification.CheckUnseenEventNotification: exception", error);
    }
  }

  public TriggerUnseenEventNotification(Api_EventNotification:any, AmbitMessageId:number, context:string)
  {
    //if (this.consoleLog) 
    console.log("Notification.TriggerUnseenEventNotification: EVENT NOTIFICATION - AmbitMessageId:" + AmbitMessageId + " - " + context);
    
    let _NotificationData = new NotificationData();
    _NotificationData.NotificationSourceCode = Constants.NOTIFICATION_SOURCE_UNSEEN; 
    _NotificationData.NotificationTypeCode = Constants.NOTIFICATION_TYPE_EVENTNOTIFICATION; // "SURVEY";
    _NotificationData.IsActive = true;

    // Specific details from API Response via MobileEventLatest.EventNotification (see JSON below)
    _NotificationData.AmbitMessageId = Api_EventNotification.AmbitMessageId;

    _NotificationData.MessageTitle = Constants.MESSAGE_TITLE_EVENTNOTIFICATION; // 'Event Notification';
    _NotificationData.MessageSubTitle = Api_EventNotification.SentByDisplayName;
    _NotificationData.MessageText = Api_EventNotification.MessageText;

    this.PublishNotificationAlert(_NotificationData);

    /*
      MobileEventLatest:
        EventNotification:
          AmbitMessageId: 223
          AmbitMessageLiveFlag: true
          ApiLogId: 7051590
          DepartmentId: 6
          DeviceReceiveDatetime: "0001-01-01T00:00:00"
          DeviceReceiveDatetimeUtc: "0001-01-01T00:00:00"
          DeviceReceiveMobileDatetime: "0001-01-01T00:00:00"
          DisplayName: "Peter Ambit3"
          EventId: 219763
          EventLiveFlag: false
          LastStatusCode: "MESSAGE_PENDING"
          LastStatusDatetime: "2019-05-14T23:07:09.203"
          LastStatusDatetimeUtc: "2019-05-14T23:07:09.203"
          LastStatusId: 1
          LastStatusInfo: "Message pending.  About to push message"
          LiveFlag: true
          MessagePushDatetime: "0001-01-01T00:00:00"
          MessagePushDatetimeUtc: "0001-01-01T00:00:00"
          MessagePushIdentifier: null
          MessagePushStatusCode: null
          MessagePushStatusDescription: null
          MessageText: "Ahmed, Zeshaan  logged in to the System Client"
          MobileDatetime: "0001-01-01T00:00:00"
          MobileLocationId: 0
          MobileUserId: 14117
          PriorityFlag: false
          SentByDepartmentId: 6
          SentByDisplayName: "Ahmed, Zeshaan "
          SentByMobileLocationId: 3021883
          SentByMobileUserId: 10722
          SentBySiteId: 3
          SentBySystemUserId: 0
          SiteId: 10145
          SystemSentDatetime: "2019-05-14T23:07:09.203"
          SystemSentDatetimeUtc: "2019-05-14T23:07:09.203"
          UserResponseDatetime: "0001-01-01T00:00:00"
          UserResponseDatetimeUtc: "0001-01-01T00:00:00"
          UserResponseMobileDatetime: "0001-01-01T00:00:00"
    */
  }

  public TriggerPushEventNotificationDisplay(ambitPushGeneral:AmbitPushGeneral, eventNotificationPush:EventNotificationPush, ForegroundStatus:string)
  {
    if (this.consoleLog) console.log("Notification.TriggerPushEventNotificationDisplay: " + ForegroundStatus, eventNotificationPush);
    
    let _NotificationData = new NotificationData();
    _NotificationData.NotificationSourceCode = Constants.NOTIFICATION_SOURCE_PUSH; 
    _NotificationData.NotificationTypeCode = Constants.NOTIFICATION_TYPE_EVENTNOTIFICATION; // "SURVEY";
    _NotificationData.IsActive = true;

    // Specific details from Push Notification via ambitMessagePush
    _NotificationData.AmbitMessageId = ambitPushGeneral.AmbitMessageId; 

    _NotificationData.MessageTitle = eventNotificationPush.MessageTitle;
    _NotificationData.MessageSubTitle = eventNotificationPush.MessageSubTitle;
    _NotificationData.MessageText = eventNotificationPush.MessageText;
    
    this.PublishNotificationAlert(_NotificationData);
  }
  
  // ----------------------------------------------------------------------------------------
  // PUSH or UNSEEN - ACTIONABLE BROADCAST
  // ----------------------------------------------------------------------------------------

  public CheckUnseenAmbitMessage(Api_AmbitMessage:any, context:string)
  {
    if (this.consoleLog) console.log("Notification.CheckUnseenAmbitMessage: " + context, Api_AmbitMessage);
   
    try
    {
      if ((!Api_AmbitMessage) || (!Api_AmbitMessage.AmbitMessageId)) { return; }  // basic check upfront

      if (this.consoleLog) console.log("Notification.CheckUnseenAmbitMessage: " + context + " - AMBITMESSAGE - checking AmbitMessageId:" + Api_AmbitMessage.AmbitMessageId, Api_AmbitMessage);
      let AmbitMessageIdInteger:number = parseInt(Api_AmbitMessage.AmbitMessageId, 10);
      let EventIdInteger:number = parseInt(Api_AmbitMessage.EventId, 10);
      if (!this.globalProvider.LatestAmbitMessage.HasThisAmbitMessageBeenSeenAlready(AmbitMessageIdInteger))
      {
        if (this.consoleLog) console.log("Notification.CheckUnseenAmbitMessage: " + context + " - AMBITMESSAGE - UNSEEN so will TRIGGER AmbitMessageId:" + Api_AmbitMessage.AmbitMessageId, Api_AmbitMessage);
        // mark this as RECEIVED so that we don't double up (even though it is in the process of being received)
        this.globalProvider.SetStorageObject_LatestAmbitMessage(AmbitMessageIdInteger, EventIdInteger, "RECEIVED");
        this.TriggerUnseenAmbitMessage(Api_AmbitMessage, AmbitMessageIdInteger, context);
      } 
      else
      {
        if (this.consoleLog) console.log("Notification.CheckUnseenAmbitMessage: " + context + " - AMBITMESSAGE - ALREADY SEEN AmbitMessageId:" + Api_AmbitMessage.AmbitMessageId, Api_AmbitMessage);
      }
    }
    catch (error)
    {
      console.error("Notification.CheckUnseenAmbitMessage: exception", error);
    }
  }

  public TriggerUnseenAmbitMessage(Api_AmbitMessage:any, AmbitMessageId:number, context:string)
  {
    //if (this.consoleLog) 
    console.log("Notification.TriggerUnseenAmbitMessage: AMBIT MESSAGE - AmbitMessageId:" + AmbitMessageId + " - " + context);
    
    let _NotificationData = new NotificationData();
    _NotificationData.NotificationSourceCode = Constants.NOTIFICATION_SOURCE_UNSEEN; 
    _NotificationData.NotificationTypeCode = Constants.NOTIFICATION_TYPE_AMBITMESSAGE; // "SURVEY";
    _NotificationData.IsActive = true;

    // Specific details from API Response via MobileEventLatest.AmbitMessage (see JSON below)
    _NotificationData.AmbitMessageId = Api_AmbitMessage.AmbitMessageId;

    _NotificationData.MessageTitle = Constants.MESSAGE_TITLE_AMBITMESSAGE; // 'Ambit Message Alert';
    _NotificationData.MessageSubTitle = Api_AmbitMessage.SentByDisplayName;
    _NotificationData.MessageText = Api_AmbitMessage.MessageText;

    this.PublishNotificationAlert(_NotificationData);

    /*
      MobileEventLatest:
        AmbitMessage:
          AmbitMessageId: 222
          AmbitMessageLiveFlag: true
          ApiLogId: 7051529
          DepartmentId: 6
          DeviceReceiveDatetime: "0001-01-01T00:00:00"
          DeviceReceiveDatetimeUtc: "0001-01-01T00:00:00"
          DeviceReceiveMobileDatetime: "0001-01-01T00:00:00"
          DisplayName: "Peter Ambit3"
          EventId: 219760
          EventLiveFlag: true
          LastStatusCode: "NO_PUSH"
          LastStatusDatetime: "2019-05-14T22:49:59.09"
          LastStatusDatetimeUtc: "2019-05-14T22:49:59.09"
          LastStatusId: 8
          LastStatusInfo: "Notification Message not supported for this device"
          LiveFlag: true
          MessagePushDatetime: "0001-01-01T00:00:00"
          MessagePushDatetimeUtc: "0001-01-01T00:00:00"
          MessagePushIdentifier: null
          MessagePushStatusCode: null
          MessagePushStatusDescription: null
          MessageText: "Test ambit message sent from System Client (test3)"
          MobileDatetime: "0001-01-01T00:00:00"
          MobileLocationId: 0
          MobileUserId: 14117
          PriorityFlag: false
          SentByDepartmentId: 6
          SentByDisplayName: "Peter Maxxess"
          SentByMobileLocationId: 0
          SentByMobileUserId: 10560
          SentBySiteId: 10147
          SentBySystemUserId: 10159
          SiteId: 10145
          SystemSentDatetime: "2019-05-14T22:49:59.083"
          SystemSentDatetimeUtc: "2019-05-14T22:49:59.083"
          UserResponseDatetime: "0001-01-01T00:00:00"
          UserResponseDatetimeUtc: "0001-01-01T00:00:00"
          UserResponseMobileDatetime: "0001-01-01T00:00:00"
    */
  }

  public TriggerPushAmbitMessageDisplay(ambitPushGeneral:AmbitPushGeneral, ambitMessagePush:AmbitMessagePush, ForegroundStatus:string)
  {
    if (this.consoleLog) console.log("Notification.TriggerPushAmbitMessageDisplay: " + ForegroundStatus, ambitPushGeneral);
    
    // or do this the same way as the survey/actionable forms.
    let _NotificationData = new NotificationData();
    _NotificationData.NotificationSourceCode = Constants.NOTIFICATION_SOURCE_PUSH; 
    _NotificationData.NotificationTypeCode = Constants.NOTIFICATION_TYPE_AMBITMESSAGE; // "SURVEY";
    _NotificationData.IsActive = true;

    // Specific details from Push Notification via ambitMessagePush
    _NotificationData.AmbitMessageId = ambitPushGeneral.AmbitMessageId; 
    
    _NotificationData.MessageTitle = ambitMessagePush.MessageTitle;
    _NotificationData.MessageSubTitle = ambitMessagePush.MessageSubTitle;
    _NotificationData.MessageText = ambitMessagePush.MessageText;

    this.PublishNotificationAlert(_NotificationData);
  }

  // ========================================================================================
  // PUBLISH EVENT TO APP FOR IMMEDIATE DISPLAY AS MODAL WINDOW OR ALERT DIALOG 
  // ========================================================================================

  // Send that information to all the subscribers
  public PublishNotificationAlert(notificationData:NotificationData) 
  {
    if (this.consoleLog) console.log("Notification.PublishNotificationAlert", notificationData);

    if (!notificationData) 
    {
      console.error("Notification.PublishNotificationAlert: no data provided");
      return;
    }

    // make sure mobile user is logged in before attempting to route elsewhere
    if (this.globalProvider.MobileUserProfile.ActiveLogin === false)
    {
      console.warn("Notification.PublishNotificationAlert: mobile user not logged in - ignoring alert");
      return;
    }

    if (this.consoleLog) console.log("Notification.PublishNotificationAlert: IsActive: " + notificationData.IsActive);
    this._isNotification = notificationData.IsActive;
    
    // ====================================================================================
    this.events.publish('isNotification', { NotificationData: notificationData });
    // ====================================================================================
  }


  // ========================================================================================


  // ----------------------------------------------------
  // ---------          API FUNCTIONS          ----------
  // ----------------------------------------------------
  CallGetDashboardStatusForMobile(pageName:string, isCheckUnseenNotificationss:boolean)
  {
    if (!this.globalProvider.MobileUserProfile.ActiveLogin) { return; }

    if (this.consoleLog) console.log("Notification.CallGetDashboardStatusForMobile: " + pageName);
    
    this.apiProvider.GetDashboardStatusForMobile()
    .then(data => { 
      this.zone.run(() => {
        if (this.consoleLog) console.log("Notification.CallGetDashboardStatusForMobile: " + pageName + " - OK");
        
        if (isCheckUnseenNotificationss === true)
        {
          if (this.consoleLog) console.log("Notification.CallGetDashboardStatusForMobile: " + pageName + " --> CheckUnseenNotifications");
          this.CheckUnseenNotifications(data, pageName);  // if any
        }
        //this.StoreGetDashboardStatusForMobile(data);
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        console.warn("Notification.CallGetDashboardStatusForMobile: " + pageName + " - ERROR", errorMessage);
      });
    });
  }

  CallReceivedNotificationForAmbitMessage(AmbitEventTypeCode:string, NotificationTypeCode:string, AmbitMessageId:number, EventId:number, AbstractId:number)
  {
    if (this.consoleLog) console.log('Notification.CallReceivedNotificationForAmbitMessage - AmbitEventTypeCode:' + AmbitEventTypeCode + ' - EventId:' + EventId + ' - AmbitMessageId:' + AmbitMessageId + ' - AbstractId:' + AbstractId );

    this.apiProvider.ReceivedNotificationForAmbitMessage(AmbitEventTypeCode, NotificationTypeCode, AmbitMessageId, EventId, AbstractId)
    .then(data => { 
      this.zone.run(() => {
        if (this.consoleLog) console.log("CallReceivedNotificationForAmbitMessage OK - AmbitEventTypeCode:" + AmbitEventTypeCode, data);
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        console.warn("CallReceivedNotificationForAmbitMessage ERROR - AmbitEventTypeCode:" + AmbitEventTypeCode, errorMessage);
      });
    });
  }

  CallReceivedNotificationForActionableForm(ActionableBroadcastId:number, ActionableRecipientId:number)
  {
    if (this.consoleLog) console.log('Notification.CallReceivedNotificationForActionableForm - ActionableBroadcastId:' + ActionableBroadcastId + ' - ActionableRecipientId:' + ActionableRecipientId );

    this.apiProvider.ReceivedNotificationForActionableForm(ActionableBroadcastId, ActionableRecipientId)
    .then(data => { 
      this.zone.run(() => {
        if (this.consoleLog) console.log("CallReceivedNotificationForActionableForm OK - ActionableBroadcastId:" + ActionableBroadcastId + ' - ActionableRecipientId:' + ActionableRecipientId, data);
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        console.warn("CallReceivedNotificationForActionableForm ERROR", errorMessage);
      });
    });
  }

  CallReceivedNotificationForSystemSurvey(SurveyBroadcastId:number, SurveyRecipientId:number)
  {
    if (this.consoleLog) console.log('Notification.CallReceivedNotificationForActionableForm - SurveyBroadcastId:' + SurveyBroadcastId + ' - SurveyRecipientId:' + SurveyRecipientId );

    this.apiProvider.ReceivedNotificationForActionableForm(SurveyBroadcastId, SurveyRecipientId)
    .then(data => { 
      this.zone.run(() => {
        if (this.consoleLog) console.log("CallReceivedNotificationForActionableForm OK - SurveyBroadcastId:" + SurveyBroadcastId + ' - SurveyRecipientId:' + SurveyRecipientId, data);
      });
     }
    , 
    errorMessage => {
      this.zone.run(() => {
        console.warn("CallReceivedNotificationForActionableForm ERROR", errorMessage);
      });
    });
  }

  // ----------------------------------------------------
  // ------ FIREBASE PUSH MESSAGING NOTIFICATION  -------
  // ----------------------------------------------------

  myTranslate(value:string):string
  {
    // WARNING! inline translation will CRASH if the value is empty
    if (!value) { return ""; }
    return this.translate.instant(value);
  }

  public GetNotificationStatus(ambitPushGeneral:AmbitPushGeneral):string
  {
    let LatestNotificationStatus 
    = this.myTranslate("Received Push") + " "
    + this.myTranslate(ambitPushGeneral.NotificationTypeCode) + " "
    + "- EventID:" + ambitPushGeneral.EventId
    + " (" + this.myTranslate(ambitPushGeneral.ForegroundStatus) + " " +  + ambitPushGeneral.ApiLogId + ")";

    // ambitPushGeneral.AmbitMessageId
    // ambitPushGeneral.ActionableBroadcastId
    // ambitPushGeneral.SurveyBroadcastId
    // ambitPushGeneral.SurveyRecipientId
    // ambitPushGeneral.AbstractId
    
    return LatestNotificationStatus;
  }

  public HandlePushReceived(notificationPayload:any, ForegroundStatus:string):boolean
  {
    try
    {
      if (this.consoleLog) console.log('Notification.HandlePushReceived - ForegroundStatus:' + ForegroundStatus, notificationPayload);

      let ambitPushGeneral:AmbitPushGeneral = new AmbitPushGeneral(notificationPayload, ForegroundStatus);
      let LatestNotificationStatus = this.GetNotificationStatus(ambitPushGeneral);

      // send a toast message for the notification
      this.commonProvider.presentToast(LatestNotificationStatus);

      // set the latest message internally
      this.globalProvider.SetStorageObject_PushConfig_LatestReceived( ambitPushGeneral.NotificationTypeCode
                                                                    , LatestNotificationStatus
                                                                    , ambitPushGeneral.EventId
                                                                    );

      // set the badge (back) to the event count from before rather than the push message count                                                              
      this.globalProvider.SetAppIconBadgeCount();

      switch (ambitPushGeneral.NotificationTypeCode) // .AmbitEventTypeCode
      {
        case Constants.NOTIFICATION_TYPE_ACTIONABLE:
        {
          console.log('Notification.HandlePushReceived: ACTIONABLE');
          let broadcastPush:BroadcastPush = new BroadcastPush(notificationPayload);

          // maybe this notification received call is not necessary because the following display call is effectively the same thing
          //this.CallReceivedNotificationForActionableForm(broadcastPush.SurveyBroadcastId, notificationPayload.SurveyRecipientId);
          this.TriggerPushActionableFormDisplay(ambitPushGeneral, broadcastPush, ForegroundStatus);
          break;
        }

        case Constants.NOTIFICATION_TYPE_SURVEY:
        {
          console.log('Notification.HandlePushReceived: SURVEY');
          let broadcastPush:BroadcastPush = new BroadcastPush(notificationPayload);

          // maybe this notification received call is not necessary because the following display call is effectively the same thing
          //this.CallReceivedNotificationForSystemSurvey(broadcastPush.SurveyBroadcastId, notificationPayload.SurveyRecipientId);
          this.TriggerPushSurveyDisplay(ambitPushGeneral, broadcastPush, ForegroundStatus);
          break;
        }

        case Constants.NOTIFICATION_TYPE_MONITOR:
        {
          // ToDo: allow monitor chat to come in real-time and update the monitor chat screen if it is active
          console.log('Notification.HandlePushReceived: MONITOR');
          //this.TriggerPushAmbitMessageDisplay(ambitPushGeneral, ambitMessagePush, ForegroundStatus);
          break;
        }

        case Constants.NOTIFICATION_TYPE_AMBITMESSAGE:
        {
          console.log('Notification.HandlePushReceived: AMBITMESSAGE');
          // set the latest message in the cloud (ToDo -- this is not complete yet)
          //this.CallReceivedNotificationForAmbitMessage( ambitPushGeneral.AmbitEventTypeCode, ambitPushGeneral.NotificationTypeCode
          //    , ambitPushGeneral.AmbitMessageId, ambitPushGeneral.EventId, notificationPayload.SurveyRecipientId);

          let ambitMessagePush:AmbitMessagePush = new AmbitMessagePush(notificationPayload);
          this.TriggerPushAmbitMessageDisplay(ambitPushGeneral, ambitMessagePush, ForegroundStatus);
          //  this.AlertAmbitMessageDisplay(ambitPushGeneral, ambitMessagePush, ForegroundStatus);
          break;
        }

        case Constants.NOTIFICATION_TYPE_EVENTNOTIFICATION:
        {
          console.log('Notification.HandlePushReceived: EVENTNOTIFICATION');
          let eventNotificationPush:EventNotificationPush = new EventNotificationPush(notificationPayload);
          this.TriggerPushEventNotificationDisplay(ambitPushGeneral, eventNotificationPush, ForegroundStatus);
          //  this.AlertAmbitMessageDisplay(ambitPushGeneral, ambitMessagePush, ForegroundStatus);
          break;
        }

        default:
        {
          console.warn('Notification.HandlePushReceived: UNKNOWN');
          alert("Push Notification - Unknown or Blank Type:" + ambitPushGeneral.NotificationTypeCode);
          this.CallReceivedNotificationForAmbitMessage( ambitPushGeneral.AmbitEventTypeCode, ambitPushGeneral.NotificationTypeCode
              , ambitPushGeneral.AmbitMessageId, ambitPushGeneral.EventId, notificationPayload.SurveyRecipientId);
          break;
        }
      }
      return true;
    }
    catch (error)
    {
      console.error('Notification.HandlePushReceived: ERROR ', error);
      alert("Error processing push notification - please contact support");

      let MainMessage:string = this.GetMainMessage(notificationPayload);
      this.commonProvider.presentToast(MainMessage, ForegroundStatus + " Push pushNotification (ERROR PROCESSING)");
      return false;
    }
  }

  public GetMainMessage(pushNotification:any):string
  {
    if (this.consoleLog) console.log('Notification.GetMainMessage', pushNotification);
    if (!pushNotification) { return "Empty pushNotification"; }

    if (this.consoleLog) console.log('Notification.GetMainMessage evaluating message', pushNotification.message);
    if (!pushNotification.message) { return "Empty pushNotification Message"; }

    if (this.consoleLog) console.log('Notification.GetMainMessage - message:' + pushNotification.message);
    return pushNotification.message;
  }

}


